module.exports = __webpack_public_path__ + "static/media/tire-pressure-check.382a5621.svg";